import Vue from "vue";
import Vant from "vant";
import "vant/lib/index.css";

import "./plugins/axios";
import "./plugins/repo";
import "./plugins/event_listener";
import "./register_service_worker";
import store from "./store";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/index.scss";
import "./assets/css/app.css";
// import VueGeolocation from "vue-browser-geolocation";
// Vue.use(VueGeolocation);

import * as firebase from "firebase";

// import * as VueGoogleMaps from "vue2-google-maps";

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyB5sdMWvB4J4X8W9Z6fuiNNaKI1eYUXLK4",
//     libraries: "places", // necessary for places input
//   },
//   autobindAllEvents: true,
//   installComponents: true,
// });

// Config firebase project
const firebaseConfig = {
  apiKey: "AIzaSyDwUQUFtq3U0EBCcisFcf73FLakuMPDnss",
  authDomain: "hurryup-app.firebaseapp.com",
  databaseURL: "https://hurryup-app.firebaseio.com",
  projectId: "hurryup-app",
  storageBucket: "hurryup-app.appspot.com",
  messagingSenderId: "597597224936",
  // appId: "1:597597224936:web:c746752ba2983c77d9ae5d",
  // measurementId: "G-REJPVQ702K"
};

firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;
Vue.use(Vant);

window.addEventListener("load", () => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
